import React from 'react'
import './Experience.css'
import INCHIK from '../../assets/workplaces-icons/inchik.jpg'
import STARGAZER from '../../assets/workplaces-icons/stargazer.png'
import SOUTHWARD from '../../assets/workplaces-icons/southward_solutions.png'
import LEIA from '../../assets/workplaces-icons/leia.png'
import SERHANT from '../../assets/workplaces-icons/serhant.png'
import PANBIAS from '../../assets/workplaces-icons/panbias.png'
import KOMBO from '../../assets/workplaces-icons/kombo.png'
import WorkCard from './WorkCard'

function WorkCards(props) {
  return (
    <>
      {/* Current Position - Leia */}
      <WorkCard
        badgeText="Current"
        workplaceClass="leia"
        workplaceName="Leia"
        jobPosition={<>Tech Lead &<br/>Product Owner</>}
        workUrl={"https://app.leia.ar/"}
        logo={LEIA}
        workDescription={
          <>
            Leading technical vision and product strategy for an AI-powered legal platform serving Argentina and Brazil markets.
            <br /><br />
            Built the complete MVP independently, including web scraping APIs to collect legal data from National Law organisms.
            <br /><br />
            Driving product roadmap while maintaining hands-on technical leadership across the full stack.
            <br /><br />
            <strong>Industry:</strong> Legal Tech | <strong>Location:</strong> Argentina/Brazil (Remote)
          </>
        }
      />

      {/* SERHANT */}
      <WorkCard
        badgeText="1 Year"
        workplaceClass="serhant"
        workplaceName="SERHANT."
        jobPosition={<>Software Engineer<br/>Automations Team</>}
        workUrl={"https://serhant.com/"}
        logo={SERHANT}
        workDescription={
          <>
            Designed automated workflows using AI tools to streamline operations for real estate advisors and internal teams.
            <br /><br />
            Collaborated with distributed stakeholders across time zones to gather requirements and deliver tailored solutions.
            <br /><br />
            Built scalable automation systems leveraging Python, Azure, LangChain, and LLM technologies.
            <br /><br />
            <strong>Industry:</strong> Real Estate | <strong>Location:</strong> United States (Remote)
          </>
        }
      />

      {/* Stargazer - Updated, no longer current */}
      <WorkCard
        badgeText="3+ Years"
        workplaceClass="stargazer"
        workplaceName="Stargazer"
        jobPosition="Software Engineer"
        workUrl={"https://www.stargazer.co/"}
        logo={STARGAZER}
        workDescription={
          <>
            Progressed to co-leading technical ownership of all company products across 5 applications (B2B, B2C, Auth, Internal, CRM).
            <br /><br />
            <strong>AI Development:</strong> Built celebs.chat AI bot tested with celebrity clients using LangChain, OpenAI, RAG, and PgVector.
            <br /><br />
            Developed Automated Influencer Ad system generating video ads using OpenAI, Eleven Labs, and image-to-video models.
            <br /><br />
            <strong>Tech:</strong> React.js, Next.js, Node.js, Python, AWS, PostgreSQL, MongoDB, LangChain
            <br /><br />
            <strong>Industry:</strong> Digital Marketing | <strong>Location:</strong> Miami, FL (Remote)
          </>
        }
      />

      {/* KomboAI */}
      <WorkCard
        badgeText="6 Months"
        workplaceClass="komboai"
        workplaceName="KomboAI"
        jobPosition={<>Senior Software<br/>Engineer - AI</>}
        workUrl={"#"}
        logo={KOMBO}
        workDescription={
          <>
            Led LLM integration and fine-tuning initiatives for the AI team at this early-stage startup.
            <br /><br />
            Refactored entire legacy codebase and delivered new MVP features in under 2 weeks.
            <br /><br />
            Built infrastructure for automated data gathering and fine-tuning pipelines.
            <br /><br />
            <strong>Industry:</strong> Sales | <strong>Location:</strong> Spain (Remote)
          </>
        }
      />

      {/* Southward Solutions - Updated description */}
      <WorkCard
        badgeText="2 Years"
        workplaceClass="southward"
        workplaceName={<>Southward <br/> Solutions </>}
        jobPosition="Full Stack Developer"
        workUrl={"https://www.southward-solutions.com.ar/"}
        logo={SOUTHWARD}
        workDescription={
          <>
            Developed internal systems for supermarkets across the LATAM region, working with NCR Corporation as a client.
            <br /><br />
            Overhauled legacy projects to modern technologies (Vue.js, Java) and developed CRM/CRUD web applications.
            <br /><br />
            Trained new employees and maintained direct client communication across multiple time zones.
            <br /><br />
            <strong>Industry:</strong> Retail | <strong>Location:</strong> Argentina (Remote)
          </>
        }
      />

      {/* PANBIAS - Entrepreneurial */}
      <WorkCard
        badgeText="Founder"
        workplaceClass="panbias"
        workplaceName="PANBIAS"
        jobPosition={<>Founder &<br/>Technical Director</>}
        workUrl={"#"}
        logo={PANBIAS}
        workDescription={
          <>
            Founded software consultancy delivering scalable projects for a diverse client portfolio.
            <br /><br />
            Managing business operations, client relationships, and coordinating a network of developers.
            <br /><br />
            <strong>Location:</strong> Spain | <strong>Since:</strong> April 2023
          </>
        }
      />

      {/* Inchik - Keeping as early experience */}
      <WorkCard
        badgeText="Side Project"
        workplaceClass="inchik"
        workplaceName={"Inchik"}
        workUrl={"https://www.instagram.com/inchik_arg/?hl=es"}
        jobPosition={<>Full Stack Developer<br/>& Designer</>}
        logo={INCHIK}
        workDescription={
          <>
            Software implementation and design for local startup, building inventory management system.
            <br /><br />
            The application enables users to track accounting variables including vendors, stock, and sales with automation tools for buying, selling, and inventory distribution.
            <br /><br />
            Developed and designed the data architecture, directory structure, and UI/UX independently.
            <br /><br />
            <strong>Tech:</strong> React.js, Material UI, JavaScript, SQL, Express, Axios, Node, CSS
          </>
        }
      />

    </>
  )
}

export default WorkCards
